import { Box, Grid, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import ProductImageCarousel from "./ProductImageCarousel";
import ProductIcon from "./ProductIcon";
import ProductAccordionList from "./ProductAccordionList";
import ProductOptions from "./ProductOptions";
import useSWR from "swr";
import { PATH_NAME } from "../../../configs/pathName";
import { generalFetcher } from "../../../helpers/Fetchers/fetchers";
import { useEffect, useState } from "react";
import { ISkuDetail } from "../../../models/ISkuDetail";
import assets from "../../../assets";
import colorConfigs from "../../../configs/colorConfigs";
import { typo } from "../../../assets/fonts/font";
import { getBadgeByID } from "../../../api/BadgeAPI";

const featureLogoArray = [
  assets.images.halalLogo,
];

const ProductPage = () => {
  const { slug } = useParams<{ slug?: string }>();
  const {
    data: skuDetails,
    isLoading,
    error,
  }: { data: ISkuDetail; isLoading: boolean; error: any } = useSWR(
    slug ? PATH_NAME.API_GET_SKU_DETAILS_BY_SLUG(slug) : null,
    generalFetcher
  );

  const [badgeArray, setBadgeArray] = useState<string[]>([]);

  const [imageArray, setImageArray] = useState<string[]>([]);

  useEffect(() => {
    if (skuDetails && skuDetails.image_url) {
      const imageUrls = [
        skuDetails.image_url,
        ...skuDetails.additional_image_urls,
      ];
      setImageArray(imageUrls);
    }
  }, [skuDetails]);

  useEffect(()=>{
    if(skuDetails && skuDetails.batches !== undefined){
      const fetchBadgeFilenames = async () => {
        try{

          const badgeFilenames = await Promise.all(
            skuDetails.batches.map(async (badgeId) => {
              const badge = await getBadgeByID(badgeId);
              return badge.filename as string;
            })
          );
          setBadgeArray(badgeFilenames);
        }catch(error){
          console.log(error);
        }
      };
      fetchBadgeFilenames();
    }
  }, [skuDetails]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error</div>;
  }

  if (!slug || !skuDetails || !skuDetails.sku_sku) {
    return <div>Product not found</div>;
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: colorConfigs.secondary,
      }}
    >
      <Grid
        container
        sx={{
          display: "grid",
          gridTemplateAreas: {
            xs: `
            "carousel"
            "description"
            "badge"
            "options"
            "accordion"
          `,
            md: `
            "carousel description"
            "carousel options"
            "badge options"
            "accordion options"
          `,
          },
          gridTemplateColumns: { xs: "1fr", md: "1fr 2fr" },
        }}
      >
        <Grid item sx={{ padding: "1rem", gridArea: "carousel" }}>
          <Box
            sx={{
              width: "100%",
              aspectRatio: "1/1",
              maxHeight: "500px",
              overflow: "hidden",
            }}
          >
            <ProductImageCarousel imageArray={imageArray} />
          </Box>
        </Grid>
        <Grid item sx={{ padding: "1rem", gridArea: "badge" }}>
          <Box>
            <ProductIcon productIconArray={badgeArray} />
          </Box>
        </Grid>
        <Grid item sx={{ padding: "1rem", gridArea: "accordion" }}>
          <ProductAccordionList skuDetails={skuDetails} />
          <Box sx={{marginTop: "1rem"}}>
            <ProductIcon productIconArray={featureLogoArray} isAsset={true} size="small" />
          </Box>
        </Grid>
        <Grid item sx={{ padding: "1rem", gridArea: "description" }}>
          <Box
            sx={{
              backgroundColor: "inherit",
              wordBreak: "break-word",
            }}
          >
            <Typography sx={{ ...typo.sectionHeadline }}>
              {skuDetails.name}
            </Typography>
            <Typography sx={{ ...typo.bodyContent , whiteSpace:"pre-line"}}>
              {skuDetails.description}
            </Typography>
            <Typography sx={{ ...typo.title }}>
              ${" "}
              {skuDetails.price !== undefined
                ? skuDetails.price.toFixed(2)
                : "NaN"}
            </Typography>
          </Box>
        </Grid>
        <Grid item sx={{ padding: "1rem", gridArea: "options" }}>
          <ProductOptions skuDetails={skuDetails} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductPage;
